import React, { memo } from "react";
import { graphql, useFragment } from "react-relay";
import { AHIcon, ListItem } from "arkh";

import { RoleListItem_role$key } from "./__generated__/RoleListItem_role.graphql";
import { ListItemEmployees } from "../TodoListItem/TodoListItemFooter/ListItemEmployees";

export type RoleListItemProps = {
  role: RoleListItem_role$key;
  selected: boolean;
  onPress: (id: string) => void;
  disabled?: boolean;
  /** When true, shows a lock icon instead of SelectIndicator to indicate the role is assigned at a higher level and can't be changed here */
  locked?: boolean;
};

export const RoleListItem = memo(RoleListItemC);

function RoleListItemC(props: RoleListItemProps) {
  const role = useFragment(
    graphql`
      fragment RoleListItem_role on EmployeeRole {
        id
        name
        employees {
          ...ListItemEmployees_employees
        }
      }
    `,
    props.role
  );

  const isDisabled = props.disabled || props.locked;

  return (
    <ListItem
      disabled={isDisabled}
      onPress={() => props.onPress(role.id)}
      left={<AHIcon type="employee-role" size="small" color="text-secondary" />}
      right={
        props.locked ? (
          <AHIcon type="locked" size="small" color="text-washed" />
        ) : (
          <ListItem.SelectIndicator selected={props.selected} />
        )
      }
      footer={
        role.employees.length > 0 ? (
          <ListItemEmployees
            employees={role.employees}
            nameDisplayMode="all"
            effectiveMaxEmployees={3}
            highlightViewer={false}
            currentEmployeeId={undefined}
          />
        ) : undefined
      }
    >
      <ListItem.Title>{role.name}</ListItem.Title>
    </ListItem>
  );
}
